import { Constant } from '@/_services/constant'

export default class BeaconModel {
  /* tslint:disable:variable-name */
  public _id: string = ''
  public beacon_type: string
  public beacon_uuid: string = ''
  public category_name: string = ''
  public user_id: string = ''
  public user_name: string = ''
  public major: string = ''
  public minor: string = ''
  public lon: any = ''
  public lat: any = ''
  public location_name: string = ''
  public floor_name: string = ''
  public floor_id: string = ''
  public geofence_name: string = ''
  public geofence_id: string = ''
  public created_at: Date = new Date()
  public updated_at: Date = new Date()
  public camera_address: string = ''
  public optional_type: string = ''
  public san_id: string = ''

  constructor(type: string = Constant.BEACON_TYPE_STATIC) {
    this.beacon_type = type // static | carried
  }
}
